import { createSelector } from 'reselect'

const getFetchUserRequest = state => state.User.fetchUserRequest
const getUpdateAccountRequest = state => state.User.updateAccountRequest
const getUploadAvatarRequest = state => state.User.uploadAvatarRequest
const getRemoveAvatarRequest = state => state.User.removeAvatarRequest

const getUser = state => state.User.user

const getUserAvatar = createSelector(
  [getUser],
  user => (!user ? null : user.avatar)
)

export {
  getFetchUserRequest,
  getUserAvatar,
  getUser,
  getUpdateAccountRequest,
  getUploadAvatarRequest,
  getRemoveAvatarRequest
}
